import type { SlideDeck } from '../engines/SlideDeckPlayer';

// Para agregar slides: súmalos al deck que corresponda. Para agregar un deck
// nuevo: agrega otro objeto al array — entra a la rotación de "Otro tema".
export const SLIDE_DECKS: SlideDeck[] = [
	{
		id: 'que_hace_heru',
		title: 'Qué hace heru por ti',
		emoji: '🚀',
		slides: [
			{
				emoji: '🔗',
				title: 'Leemos tu información del SAT',
				text: 'Al conectarte traemos tus facturas, retenciones y declaraciones — sin que captures nada a mano.',
			},
			{
				emoji: '🧮',
				title: 'Calculamos tus impuestos',
				text: 'Detectamos tus regímenes y armamos tus declaraciones con tu información real del SAT.',
			},
			{
				emoji: '🔔',
				title: 'Te avisamos a tiempo',
				text: 'Fechas límite, requerimientos y cambios en tu situación: te lo decimos antes de que sea problema.',
			},
			{
				emoji: '📤',
				title: 'Presentamos por ti',
				text: 'Tus declaraciones se presentan directo ante el SAT y recibes tu acuse en la app.',
			},
			{
				emoji: '🧑‍💼',
				title: 'Con humanos detrás',
				text: 'Contadores reales revisan los casos especiales. No estás solo con un bot.',
			},
		],
	},
	{
		id: 'paga_menos',
		title: 'Paga menos, legalmente',
		emoji: '💡',
		slides: [
			{
				emoji: '🧾',
				title: 'Pide factura de todo',
				text: 'Cada gasto de tu actividad con factura es impuesto que dejas de pagar. Hazlo costumbre.',
			},
			{
				emoji: '💳',
				title: 'Gastos médicos con tarjeta',
				text: 'Doctor, dentista o lentes solo deducen si pagas con tarjeta o transferencia — no en efectivo.',
			},
			{
				emoji: '🎓',
				title: 'Las colegiaturas cuentan',
				text: 'De preescolar a prepa son deducibles con tope por nivel. Pide la factura a la escuela.',
			},
			{
				emoji: '🏠',
				title: 'Tu hipoteca también',
				text: 'Los intereses reales del crédito de tu casa son deducción personal cada año.',
			},
			{
				emoji: '📅',
				title: 'Declara aunque sea en ceros',
				text: 'Mantener tu historial limpio te ahorra multas y trámites después.',
			},
		],
	},
	{
		id: 'sat_sin_miedo',
		title: 'El SAT sin miedo',
		emoji: '🦁',
		slides: [
			{
				emoji: '📬',
				title: 'El buzón tributario no muerde',
				text: 'Es el canal oficial de avisos del SAT. Tenerlo activo y al día te evita multas innecesarias.',
			},
			{
				emoji: '🟢',
				title: 'Tu opinión de cumplimiento',
				text: 'Dice si estás al corriente. Positiva = operas sin trabas; te ayudamos a mantenerla así.',
			},
			{
				emoji: '⏰',
				title: 'Atrasarse tiene arreglo',
				text: 'Siempre puedes ponerte al corriente. Entre antes lo hagas, menores los recargos.',
			},
			{
				emoji: '💸',
				title: 'El saldo a favor es real',
				text: 'Si te retuvieron de más, declarar es la forma de recuperar tu dinero.',
			},
			{
				emoji: '🔐',
				title: 'Tus datos están seguros',
				text: 'Tu contraseña del SAT solo permite consultar tu información, no mover dinero ni hacer trámites.',
			},
		],
	},
];
